/******************************************************************************************
 *	Reseller Preferred Languages Constant
 *******************************************************************************************
 *
 * List of languages selectable as "preferred languages" in the Reseller Org and Customer invitation forms.
 *
 */
(function() {
  

  angular
    .module('rcServices.resellerPreferredLanguages', [])
    .constant('RESELLER_PREFERRED_LANGUAGES', [
      {label: 'languages.english', value: 'en-us'},
      {label: 'languages.french', value: 'fr-fr'},
      {label: 'languages.german', value: 'de-de'},
      {label: 'languages.japanese', value: 'ja-jp'},
      {label: 'languages.spanish', value: 'es-es'},
      {label: 'languages.italian', value: 'it-it'},
      {label: 'languages.dutch', value: 'nl-nl'},
      {label: 'languages.swedish', value: 'sv-se'},
      {label: 'languages.portuguese', value: 'pt-pt'},
      {label: 'languages.korean', value: 'ko-kr'},
      {label: 'languages.russian', value: 'ru-ru'},
      {label: 'languages.turkish', value: 'tr-tr'},
      {label: 'languages.czech', value: 'cs-cz'},
      {label: 'languages.polish', value: 'pl-pl'},
      {label: 'languages.danish', value: 'da-dk'},
      {label: 'languages.finnish', value: 'fi-fi'},
      {label: 'languages.norwegian', value: 'nb-nl'},
      {label: 'languages.chinese', value: 'zh-tw'},
      {label: 'languages.simplifiedChinese', value: 'zh-cn'}
    ]);
})();
